import reduxStore from 'redux/store'
import {setSalesNotification} from "../redux/actions";

function useSalesNotification(functionality, successCallback) {
    return () => {
        const state = reduxStore.getState();
        if (state.resources?.demandHeader?.applicationClientSettings?.[functionality]) {
            if (state.resources.demandHeader.applicationClientSettings[functionality].active) {
                successCallback();
            } else {
                reduxStore.dispatch(setSalesNotification(state.resources.demandHeader.applicationClientSettings[functionality].functionalityName));
            }
        } else {
            console.error(`state.resources.demandHeader.applicationClientSettings.${functionality} not found`)
        }
    }
}

export default useSalesNotification;